import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentAdmin } from '../../services/adminAuthService';

/**
 * AdminAuthGuard
 * Protects admin routes by checking authentication
 * Redirects to /admin/login if not authenticated, preserving returnTo query param
 */
export default function AdminAuthGuard({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    try {
      const admin = await getCurrentAdmin();
      setIsAuthenticated(admin !== null);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading || isAuthenticated === null) {
    // Still checking authentication
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Not authenticated - redirect to login with returnTo query param
    const currentPath = location.pathname + location.search;
    const returnTo = currentPath !== '/admin/login' ? currentPath : undefined;
    const loginPath = returnTo 
      ? `/admin/login?returnTo=${encodeURIComponent(returnTo)}`
      : '/admin/login';
    return <Navigate to={loginPath} replace />;
  }

  // Authenticated - render children
  return children;
}
